module.exports = {"TXTWCL_Continue":{"id":"TXTWCL_Continue","defaultMessage":"Fortsätt","track":"Continue"}}